// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'

import "@/assets/plugins/slick/slick.css";
import "@/assets/js/jquery-2.2.3.min.js";
import "@/assets/js/currencyREM.js";



import VueDirectiveImagePreviewer from 'vue-directive-image-previewer'
import 'vue-directive-image-previewer/dist/assets/style.css'
Vue.use(VueDirectiveImagePreviewer)
Vue.config.productionTip = false

// Aant UI
import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);

// 抬头
Vue.use(require('vue-wechat-title'))

// 饿了么
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

// 获取URL 参数
import getUrl_utils from './components/getUrl_utils'
Vue.prototype.$utils = getUrl_utils;




// import { Dialog } from 'vant';

// // 全局注册
// Vue.use(Dialog);
// Dialog.confirm({
//   title: '标题',
//   message: '弹窗内容'
// }).then(() => {
//   // on confirm
// }).catch(() => {
//   // on cancel
// });

//引入路由插件
import router from "./router";

/* eslint-disable no-new */
new Vue({
  el: '#app',
  components: { App },
  router,
  template: '<App/>'
})
router.afterEach((to,from,next)=>{

	　　　　window,scrollTo(0,0)
	
	　　})
  
router.beforeEach((to, from, next) => {
	if (to.meta.content) {
		let head = document.getElementsByTagName('head');
		let meta = document.createElement('meta');
		document.querySelector('meta[name="keywords"]').setAttribute('content', to.meta.content.keywords)
		document.querySelector('meta[name="description"]').setAttribute('content', to.meta.content.description)
		meta.content = to.meta.content;
		head[0].appendChild(meta)
	}

	next()
});




// WEBPACK FOOTER //
// ./src/main.js